
import { useState, useEffect } from 'react';

const CookieManager = () => {
  const [showButton, setShowButton] = useState(false);

  useEffect(() => {
    // Prüfen ob bereits eine Cookie-Einwilligung vorhanden ist
    const checkConsent = () => {
      const consent = localStorage.getItem('cookie-consent');
      if (consent) {
        setShowButton(true);
      }
    };

    // Initial prüfen
    checkConsent();

    // Event Listener für Cookie-Einwilligung
    const handleConsentGiven = () => {
      setShowButton(true);
    };

    window.addEventListener('cookieConsentGiven', handleConsentGiven);

    return () => {
      window.removeEventListener('cookieConsentGiven', handleConsentGiven);
    };
  }, []);

  const openCookieSettings = () => {
    // Trigger cookie settings modal
    const event = new CustomEvent('openCookieSettings');
    window.dispatchEvent(event);
  };

  if (!showButton) return null;

  return (
    <button
      onClick={openCookieSettings}
      className="fixed bottom-4 left-4 bg-gray-800 text-white p-3 rounded-full shadow-lg hover:bg-gray-700 transition-colors z-40"
      title="Cookie-Einstellungen"
    >
      <i className="ri-settings-3-line text-lg"></i>
    </button>
  );
};

export default CookieManager;
